import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { completeGoogleCalendarConnect } from "@/lib/partnerGoogleCalendar";

/** OAuth redirect target after Google Calendar consent. */
const PartnerCalendarCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get("code");
    const state = params.get("state");
    const oauthError = params.get("error");

    if (oauthError) {
      setError(oauthError);
      return;
    }
    if (!code || !state) {
      setError("Missing authorization code from Google.");
      return;
    }

    let cancelled = false;
    void (async () => {
      const res = await completeGoogleCalendarConnect(code, state);
      if (cancelled) return;
      if (!res.ok) {
        setError(res.message || res.error || "Could not connect Google Calendar.");
        return;
      }
      navigate("/partners/settings?calendar=connected", { replace: true });
    })();

    return () => {
      cancelled = true;
    };
  }, [params, navigate]);

  return (
    <div className="min-h-screen bg-[#f6f8fa] flex items-center justify-center p-6">
      <div className="max-w-md w-full rounded-lg border border-[#d0d7de] bg-white p-6 text-center">
        {error ? (
          <>
            <h1 className="text-lg font-semibold text-[#1f2328] mb-2">Connection failed</h1>
            <p className="text-sm text-[#656d76] mb-4">{error}</p>
            <Link
              to="/partners/settings"
              className="inline-flex rounded-md bg-[#00573C] px-4 py-2 text-sm font-semibold text-white hover:bg-[#004530]"
            >
              Back to Settings
            </Link>
          </>
        ) : (
          <>
            <div className="mx-auto mb-4 h-8 w-8 rounded-full border-2 border-[#00573C] border-t-transparent animate-spin" />
            <h1 className="text-lg font-semibold text-[#1f2328]">Connecting Google Calendar…</h1>
            <p className="text-sm text-[#656d76] mt-1">Finishing setup and syncing deadlines.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default PartnerCalendarCallback;
